export default __webpack_public_path__ + "static/media/spt21.d421f669.jpg";